export const enum ConnectorType {
  RSS = 1,
  GITHUB = 2
}